import { render, staticRenderFns } from "./_LocationDialog.vue?vue&type=template&id=c228a252&scoped=true&"
import script from "./_LocationDialog.vue?vue&type=script&lang=js&"
export * from "./_LocationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c228a252",
  null
  
)

export default component.exports